module.exports = __webpack_public_path__ + "static/img/1_2.7309d88e.jpg";